<template>
  <section>
    <div class="botones-pagina">
      <router-link :to="{name: 'formularios'}" class="boton boton--volver"/>
      <button type="button"
              class="boton boton--nuevo"
              @click="crear"/>
    </div>
    <div class="layout__title">
      <div class="text mb-2">Giras de seguimiento de:</div>
      <div class="h3">{{ consecutivo }}</div>
    </div>
    <div v-if="seguimientos.length > 0">
      <table class="tabla tabla--responsive seguimientos__tabla">
        <thead class="tabla__header">
          <tr>
            <th>Fecha de visita</th>
            <th>Hora de inicio</th>
            <th>Atendido por</th>
            <th>Estado</th>
            <th/>
          </tr>
        </thead>
        <tbody class="tabla__body tabla__body--clickable tabla__body--striped">
          <tr v-for="(seguimiento, i) in seguimientos" :key="seguimiento._id">
            <td
              data-titulo="Fecha de visita: "
              @click="ver(seguimiento, !seguimiento._id, i)"
            >
              {{ seguimiento.fechaVisitaCampo | fecha }}
            </td>
            <td
              data-titulo="Hora de inicio: "
              @click="ver(seguimiento, !seguimiento._id, i)"
            >
              {{ seguimiento.horaInicio | fecha('hh:mm a') }}
            </td>
            <td
              class="seguimientos__cell"
              data-titulo="Atendido por: "
              @click="ver(seguimiento, !seguimiento._id, i)"
            >
              {{ seguimiento.nombreAtendedor }}
            </td>
            <td
              class="estado__formulario"
              @click="ver(seguimiento, !seguimiento._id, i)"
            >
              <span v-if="seguimiento.estado === 'borrador'" class="estado estado--amarillo">
                {{ seguimiento.estado }}
              </span>
              <span v-if="seguimiento.estado === 'nuevo'" class="estado estado--azul">
                {{ seguimiento.estado }}
              </span>
              <span v-if="seguimiento.estado === 'aprobado'" class="estado estado--verde">
                {{ seguimiento.estado }}
              </span>
              <span v-if="seguimiento.estado === 'rechazado'" class="estado estado--rojo">
                {{ seguimiento.estado }}
              </span>
            </td>
            <td>
              <ul class="tabla__opciones">
                <li
                v-if="seguimiento.estado === 'rechazado'
                || seguimiento.estado === 'borrador'"
                @click="ver(seguimiento, true, i)"
                class="tabla__opciones__elem"
                tooltip="Editar">
                  <i class="text--cyan fa fa-fw fa-edit"/>
                </li>
                <li
                v-if="seguimiento.estado === 'borrador'"
                class="tabla__opciones__elem"
                tooltip="Eliminar"
                @click="eliminar(seguimiento, i)">
                  <i class="text--tomate fa fa-fw fa-trash"/>
                </li>
                <li
                v-if="seguimiento.notas"
                class="tabla__opciones__elem"
                tooltip="Notas"
                @click="abrirNotas(seguimiento.notas)">
                  <i class="text--naranja fa fa-fw fa-comment-dots"/>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="text--center" v-show="cargando">
        <i class="fa fa-spinner fa-spin fa-2x"/>
      </p>
    </div>
    <div v-else>
      <p class="no-results">
        <i class="fa fa-fw fa-list"/>
        <span>No hay seguimientos registrados.</span>
      </p>
    </div>
  </section>
</template>
<script>
import swal from "sweetalert2";
import union from "lodash/union";

export default {
  name: "SeguimientoList",
  data,
  computed: {
    seguimientos() {
      return union(
        this.$store.state.seguimiento.temporales,
        this.$store.state.seguimiento.seguimientos.docs,
      );
    },
  },
  methods: {
    ver,
    eliminar,
    fetchData,
    crear,
    abrirNotas,
    handleScroll,
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, false);
    return this.fetchData(this.pagina, {
      estado: ["nuevo", "aprobado", "rechazado"],
      inspector: this.$store.state.usuario.usuario._id,
      formulario: this.idPadre,
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, false);
  },
  props: {
    idPadre: String,
    consecutivo: String,
  },
};

function data() {
  return {
    pagina: 1,
    cantidad: this.$store.state.app.cantPorPagina,
    mapaTipos: {
      ganado: "Ganado",
      aves: "Aves",
      perros: "Perros/gatos",
    },
    cargando: false,
  };
}

function fetchData(pagina, filtro) {
  const params = { pagina: pagina - 1, cantidad: this.cantidad, filtro };
  this.pagina = pagina;
  return this.$store.dispatch(this.$actions.getBaseSeguimiento, params);
}

function ver(seguimiento, edit, pindex) {
  const index = seguimiento._id ? null : pindex;
  const params = {
    edit,
    index,
    idPadre: this.idPadre,
    consecutivo: this.consecutivo,
  };
  this.$store.commit(this.$actions.setSeguimiento, seguimiento);
  return this.$router.push({ name: "seguimiento", params });
}

function eliminar(seguimiento, index) {
  swal.fire({
    title: "Confirmación",
    text: "¿Está seguro que desea eliminar este seguimiento?",
    type: "warning",
    showCancelButton: true,
  }).then((resp) => {
    if (resp && !resp.dismiss) {
      return this.$store.commit(this.$actions.eliminarTemporal, index);
    }
    return false;
  }).catch(err => this.$toastr("error", err, "Error"));
}

function crear() {
  const index = this.$store.state.seguimiento.temporales.length;
  const params = {
    index,
    edit: true,
    idPadre: this.idPadre,
    consecutivo: this.consecutivo,
  };
  return this.$router.push({ name: "seguimiento", params });
}

function abrirNotas(text) {
  return swal.fire({
    title: "Comentarios",
    text,
  });
}

function handleScroll() {
  const finalPagina = window.scrollY === (document.body.scrollHeight - window.innerHeight);
  const cargarMas = this.$store.state.seguimiento.seguimientos.docs.length
  < this.$store.state.seguimiento.seguimientos.cant;

  if (!this.cargando && finalPagina && cargarMas) {
    const filtro = {
      estado: ["nuevo", "aprobado", "rechazado"],
      inspector: this.$store.state.usuario.usuario._id,
      formulario: this.padre,
    };
    this.cargando = true;
    this.pagina += 1;
    return this.fetchData(this.pagina, filtro).then(() => {
      this.cargando = false;
      return true;
    });
  }
  return false;
}
</script>
<style media="screen" lang="scss">
.seguimientos__cell {
  height: 40px;
}
</style>
